const getters = {
	isLogin(state, getters) {
		return state.isLogin;
	},

	userToken(state) {
		return state.userToken;
	}
};

export default getters